import cursor_move from "../assets/cursors/move.svg"
import cursor_rotate from "../assets/cursors/rotate.svg"
import cursor_resize_nwse from "../assets/cursors/resize_nwse.svg"
import cursor_resize_nesw from "../assets/cursors/resize_nesw.svg"
import plus from "../assets/icons/plus.svg"
import caret_down from "../assets/icons/caret_down.svg"
import logo from "../assets/icons/picpop_logo_ink.png"
import close_black from "../assets/icons/close_black.svg"
import upload from "../assets/icons/upload.svg"
import dummy_profile from "../assets/icons/dummy_profile.svg"
import notifications_bell from "../assets/icons/notifications_bell.svg"
import arrow_left from "../assets/icons/arrow_left.svg"
import close from "../assets/icons/close.svg"
import image_upload from "../assets/icons/image_upload.svg"
import video_upload from "../assets/icons/video_upload.svg"
import choose_image from "../assets/icons/choose_image.svg"
import choose_text from "../assets/icons/choose_text.svg"
import choose_button from "../assets/icons/choose_button.svg"
import choose_video from "../assets/icons/choose_video.svg"
import choose_social from "../assets/icons/choose_social.svg"
import stars_rating from "../assets/icons/stars_rating.svg"
import rocket from "../assets/icons/rocket.svg"
import calendar from "../assets/icons/calendar.svg"
import logo_cream from "../assets/icons/picpop_logo_cream.png"
import arrow_left_light from "../assets/icons/arrow_left_light.svg"
import google_logo from "../assets/icons/google_logo.svg"
import eye_slash from "../assets/icons/eye_slash.svg"
import upgrade from "../assets/icons/upgrade.svg"
import logout from "../assets/icons/logout.svg"
import profile from "../assets/icons/profile.svg"
import arrow_right from "../assets/icons/arrow_right.svg"
import camera from "../assets/icons/camera.svg"
import trash from "../assets/icons/trash.svg"
import trash_danger from "../assets/icons/trash_danger.svg"
import calendar_outline from "../assets/icons/calendar_outline.svg";
import calendar_outline_active from "../assets/icons/calendar_outline_active.svg";
import welcome_illustration from "../assets/images/welcome_screen_illustration.svg"
import path_slash from "../assets/icons/path_slash.svg"
import dropdown_opened from "../assets/icons/dropdown_opened.svg"
import dropdown_closed from "../assets/icons/dropdown_closed.svg"
import object_image from "../assets/icons/object_image.svg"
import object_image_active from "../assets/icons/object_image_active.svg"
import object_text from "../assets/icons/object_text.svg"
import object_text_active from "../assets/icons/object_text_active.svg"
import object_button from "../assets/icons/object_button.svg"
import object_button_active from "../assets/icons/object_button_active.svg"
import object_video from "../assets/icons/object_video.svg"
import object_video_active from "../assets/icons/object_video_active.svg"
import object_social from "../assets/icons/object_social.svg"
import object_social_active from "../assets/icons/object_social_active.svg"
import image_placeholder from "../assets/images/image_placeholder.png"
import video_placeholder from "../assets/images/video_placeholder.png"
import axis_x from "../assets/icons/axis_x.svg"
import axis_y from "../assets/icons/axis_y.svg"
import axis_z from "../assets/icons/axis_z.svg"
import replace from "../assets/icons/replace.svg"
import drag from "../assets/icons/drag.svg"
import bold from "../assets/icons/bold.svg"
import italic from "../assets/icons/italic.svg"
import underline from "../assets/icons/underline.svg"
import social_insta from "../assets/icons/social_insta.svg"
import social_insta_active from "../assets/icons/social_insta_active.svg"
import social_yt from "../assets/icons/social_yt.svg"
import social_yt_active from "../assets/icons/social_yt_active.svg"
import social_snap from "../assets/icons/social_snap.svg"
import social_snap_active from "../assets/icons/social_snap_active.svg"
import social_behance from "../assets/icons/social_behance.svg"
import social_behance_active from "../assets/icons/social_behance_active.svg"
import social_google from "../assets/icons/social_google.svg"
import social_google_active from "../assets/icons/social_google_active.svg"
import social_dropbox from "../assets/icons/social_dropbox.svg"
import social_dropbox_active from "../assets/icons/social_dropbox_active.svg"
import social_x from "../assets/icons/social_x.svg"
import social_x_active from "../assets/icons/social_x_active.svg"
import social_figma from "../assets/icons/social_figma.svg"
import social_figma_active from "../assets/icons/social_figma_active.svg"
import video_play from "../assets/icons/video_play.svg";
import video_pause from "../assets/icons/video_pause.svg";
import carousel_prev from "../assets/icons/carousel_prev.svg";
import carousel_next from "../assets/icons/carousel_next.svg";
import copy from "../assets/icons/copy.svg";
import download from "../assets/icons/download.svg";
import download_action from "../assets/icons/download_action.svg";
import download_action_active from "../assets/icons/download_action_active.svg";
import dummy_qr from "../assets/images/dummy_qr.png";
import qr_logo from "../assets/icons/qr_logo.svg";
import activity_indicator from "../assets/images/activity_indicator.gif";
import loader from "../assets/images/loader.gif";
import loader_2 from "../assets/images/loader_2.gif"
import zoom_in from "../assets/icons/zoom_in.svg";
import zoom_out from "../assets/icons/zoom_out.svg";
import transform_position from "../assets/icons/transform_position.svg";
import transform_position_active from "../assets/icons/transform_position_active.svg";
import transform_rotation from "../assets/icons/transform_rotation.svg";
import transform_rotation_active from "../assets/icons/transform_rotation_active.svg";
import transform_scale from "../assets/icons/transform_scale.svg";
import transform_scale_active from "../assets/icons/transform_scale_active.svg";
import search from "../assets/icons/search.svg"
import sort from "../assets/icons/sort.svg"
import eye from "../assets/icons/eye.svg"
import view from "../assets/icons/view.svg"
import row_view from "../assets/icons/row_view.svg";
import row_edit from "../assets/icons/row_edit.svg";
import row_download from "../assets/icons/row_download.svg";
import view_active from "../assets/icons/view_active.svg"
import arrow from "../assets/icons/arrow.svg"
import admin_nav_overview from "../assets/icons/admin/nav_overview.svg"
import admin_nav_users from "../assets/icons/admin/nav_users.svg"
import admin_nav_projects from "../assets/icons/admin/nav_projects.svg"
import admin_nav_tickets from "../assets/icons/admin/nav_tickets.svg"
import admin_stat_views from "../assets/icons/admin/stat_views.svg"
import org_image from "../assets/images/org_image.png"
import edit from "../assets/icons/edit.svg"
import plan_tick from "../assets/icons/plan_tick.svg"
import link from "../assets/icons/link.svg"
import proj from '../assets/icons/proj.svg'
import action_dots from '../assets/icons/action_dots.svg'
import more_dots from '../assets/icons/more_dots.svg'
import btn_plus from '../assets/icons/btn_plus.svg'
import btn_publish from '../assets/icons/btn_publish.svg'
import btn_phone from '../assets/icons/btn_phone.svg'
import lock from '../assets/icons/lock.svg'
import dummy_target from '../assets/icons/dummy_target.svg'
import edit_active from '../assets/icons/edit_active.svg'
import trash_active from '../assets/icons/trash_active.svg'
import user from '../assets/icons/user.svg'
import reset from "../assets/icons/reset.svg"
import link_chain from "../assets/icons/link_chain.svg"
import scale_aspect from "../assets/icons/scale_aspect.svg"
import scale_aspect_active from "../assets/icons/scale_aspect_active.svg"
import undo from "../assets/icons/undo.svg"
import redo from "../assets/icons/redo.svg"
import info_circle from "../assets/icons/info_circle.svg"
import info_circle_menu from "../assets/icons/info_circle_menu.svg"
import cloud_off from "../assets/icons/cloud_off.svg"
import tick_ink from "../assets/icons/tick_ink.svg"
import search_ink from "../assets/icons/search_ink.svg"
import chevron_down_ink from "../assets/icons/chevron_down_ink.svg"
import ban_ink from "../assets/icons/ban_ink.svg"
import trash_danger_red from "../assets/icons/trash_danger_red.svg"
import check_ink from "../assets/icons/check_ink.svg"
import sort_name_asc_ink from "../assets/icons/sort_name_asc_ink.svg"
import sort_name_desc_ink from "../assets/icons/sort_name_desc_ink.svg"
import sort_modified_ink from "../assets/icons/sort_modified_ink.svg"
import check_lime from "../assets/icons/check_lime.svg"
import lock_lime from "../assets/icons/lock_lime.svg"
import cross_muted from "../assets/icons/cross_muted.svg"
import publish_success from "../assets/icons/publish_success.svg"
const Assets = {
  plus,
  caret_down, 
  close_black,
  logo,
  upload,
  dummy_profile,
  notifications_bell,
  arrow_left,
  close,
  image_upload,
  video_upload,
  choose_image,
  choose_text,
  choose_button,
  choose_video,
  choose_social, 
  stars_rating,
  rocket,
  calendar,
  logo_cream,
  arrow_left_light,
  google_logo,
  eye_slash,
  upgrade,
  logout, 
  profile,
  arrow_right,
  camera,
  trash,
  trash_danger,
  calendar_outline,
  calendar_outline_active,
  welcome_illustration,
  path_slash,
  dropdown_opened,
  dropdown_closed,
  image_placeholder,
  video_placeholder,
  axis_x,
  axis_y,
  axis_z,
  replace,
  object_image,
  object_image_active,
  object_text,
  object_text_active,
  object_button,
  object_button_active,
  object_video,
  object_video_active,
  object_social,
  object_social_active,
  drag,
  bold,
  italic,
  underline,
  social_insta,
  social_insta_active,
  social_yt,
  social_yt_active,
  social_snap,
  social_snap_active,
  social_behance,
  social_behance_active,
  social_google,
  social_google_active,
  social_dropbox,
  social_dropbox_active,
  social_x,
  social_x_active,
  social_figma,
  social_figma_active,
  video_play,
  video_pause,
  carousel_prev,
  carousel_next,
  copy,
  download,
  download_action,
  download_action_active,
  dummy_qr,
  qr_logo,
  activity_indicator,
  zoom_in,
  zoom_out,
  transform_position,
  transform_position_active,
  transform_rotation,
  transform_rotation_active,
  transform_scale,
  transform_scale_active,
  search,
  sort,
  eye,
  view,
  row_view,
  row_edit,
  row_download,
  view_active,
  arrow,
  admin_nav_overview,
  admin_nav_users,
  admin_nav_projects,
  admin_nav_tickets,
  admin_stat_views,
  org_image,
  edit,
  plan_tick,
  link,
  proj,
  action_dots,
  more_dots,
  btn_plus,
  btn_publish,
  btn_phone,
  lock,
  dummy_target,
  loader,
  loader_2,
  edit_active,
  trash_active,
  user,
  link_chain,
  reset,
  scale_aspect,
  scale_aspect_active,
  undo,
  redo,
  info_circle,
  info_circle_menu,
  cloud_off,
  tick_ink,
  search_ink,
  chevron_down_ink,
  ban_ink,
  trash_danger_red,
  check_ink,
  sort_name_asc_ink,
  sort_name_desc_ink,
  sort_modified_ink,
  check_lime,
  lock_lime,
  cross_muted,
  publish_success,
  cursor_move,
  cursor_rotate,
  cursor_resize_nwse,
  cursor_resize_nesw
};

export default Assets;
